export const FETCH_GROUP_LIST_REQUEST = '@@toyota/FETCH_GROUP_LIST_REQUEST';
export const FETCH_GROUP_LIST_SUCCESS = '@@toyota/FETCH_GROUP_LIST_SUCESS';
export const FETCH_GROUP_LIST_FAILED = '@@toyota/FETCH_GROUP_LIST_FAILED';

export const FETCH_VEHICLE_LIST_REQUEST = '@@toyota/FETCH_VEHICLE_LIST_REQUEST';
export const FETCH_VEHICLE_LIST_SUCCESS = '@@toyota/FETCH_VEHICLE_LIST_SUCCESS';
export const FETCH_VEHICLE_LIST_FAILED = '@@toyota/FETCH_VEHICLE_LIST_FAILED';

export const GET_PNC_INFO_REQUEST = '@@toyota/GET_PNC_INFO_REQUEST';
export const GET_PNC_INFO_SUCCESS = '@@toyota/GET_PNC_INFO_SUCCESS';
export const GET_PNC_INFO_FAILED = '@@toyota/GET_PNC_INFO_FAILED';

export const CLEAR_PNC_LIST = '@@toyota/CLEAR_PNC_LIST';

export const CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE = '@@toyota/CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE';
export const CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE_SIZE = '@@toyota/CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE_SIZE';

export const DOWNLOAD_LIST_REQUEST = '@@toyota/DOWNLOAD_LIST_REQUEST';
export const DOWNLOAD_LIST_SUCCESS = '@@toyota/DOWNLOAD_LIST_SUCCESS';
export const DOWNLOAD_LIST_FAILED = '@@toyota/DOWNLOAD_LIST_FAILED';
export const CLEAR_PNC_LIST_URL = '@@toyota/CLEAR_PNC_LIST_URL';

export const SAVE_PNC_RECORDS_REQUEST = '@@toyota/SAVE_PNC_RECORDS_REQUEST';
export const SAVE_PNC_RECORDS_SUCCESS = '@@toyota/SAVE_PNC_RECORDS_SUCCESS';
export const SAVE_PNC_RECORDS_FAILED = '@@toyota/SAVE_PNC_RECORDS_FAILED';

export const EDIT_PNC_REQUEST = '@@toyota/EDIT_PNC_REQUEST';
export const EDIT_PNC_SUCCESS = '@@toyota/EDIT_PNC_REQUEST';
export const EDIT_PNC_FAILED = '@@toyota/EDIT_PNC_FAILED';

export const GET_PNC_INSTANCE_INFO_REQUEST = '@@toyota/GET_PNC_INSTANCE_INFO_REQUEST';
export const GET_PNC_INSTANCE_INFO_SUCCESS = '@@toyota/GET_PNC_INSTANCE_INFO_SUCCESS';
export const GET_PNC_INSTANCE_INFO_FAILED = '@@toyota/GET_PNC_INSTANCE_INFO_FAILED';
